import { useTranslation } from 'react-i18next';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { FinancialPlanChipSelector } from 'components/BusinessToolForm/Sections/FinancialPlan/components/FinancialPlanChipSelector';
import {
  ActiveTabContextProvider,
  useTabChangeContext,
} from 'components/BusinessToolForm/Sections/FinancialPlan/hooks/useTabChangeContext';
import {
  expenseToComponentMap,
  IPlannedExpenseValuesType,
  useGetPlannedExpenseOptions,
} from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/utils/form';

export const PlannedExpensesContent: React.FC = () => {
  const { t } = useTranslation();
  const PLANNED_EXPENSE_OPTIONS = useGetPlannedExpenseOptions();

  const { activeTab, onTabChange } = useTabChangeContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN,
    BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.PLANNED_EXPENSES,
  );

  const Component = expenseToComponentMap[activeTab.value as IPlannedExpenseValuesType];

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('financialPlan.title')}
          badgeText={t('financialPlan.plannedExpenses.title')}
        />
      </FormSectionCard>

      <FinancialPlanChipSelector options={PLANNED_EXPENSE_OPTIONS} selected={activeTab} onChange={onTabChange} />

      <Component />
    </>
  );
};

export const PlannedExpenses: React.FC = () => {
  const PLANNED_EXPENSE_OPTIONS = useGetPlannedExpenseOptions();
  return (
    <ActiveTabContextProvider initialValue={PLANNED_EXPENSE_OPTIONS[0]}>
      <PlannedExpensesContent />
    </ActiveTabContextProvider>
  );
};
